import { Link } from "@inertiajs/react";
import { ArrowRight } from "lucide-react";
import { motion } from "motion/react";

export default function CollectionTemplateHero({ collection }) {
  return (
    <section className="relative isolate min-h-[490px] overflow-hidden rounded-[2rem] bg-neutral-950 text-white sm:min-h-[560px] lg:min-h-[620px]">
      <motion.img
        initial={{ opacity: 0, scale: 1.07 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        src={collection.heroImage}
        alt={collection.heroAlt}
        className="absolute inset-0 size-full object-cover opacity-75"
      />

      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/10" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-black/10" />

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute right-[8%] top-[12%] size-28 rounded-[2rem] border border-white/15 bg-white/10 backdrop-blur-xl"
      />

      <div className="relative flex min-h-[500px] items-end p-6 sm:min-h-[460px] sm:p-10 lg:min-h-[620px] lg:items-center lg:p-16 xl:p-20">
        <motion.div
          initial={{ opacity: 0, y: 34 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.12 }}
          className="max-w-4xl"
        >
          <p className="text-xs font-black uppercase tracking-[0.34em] text-white/55">
            {collection.eyebrow}
          </p>

          <h1 className="mt-5 text-5xl font-black uppercase leading-[0.87] tracking-[-0.065em] sm:text-7xl lg:text-[7rem] xl:text-[8.5rem]">
            {collection.title}
          </h1>

          <p className="mt-7 max-w-2xl text-sm leading-7 text-white/70 sm:text-lg sm:leading-8">
            {collection.description}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              href={collection.primaryAction.href}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-black uppercase text-black transition hover:-translate-y-0.5 hover:bg-neutral-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black"
            >
              {collection.primaryAction.label}
              <ArrowRight className="size-4" />
            </Link>

            <Link
              href={collection.secondaryAction.href}
              className="inline-flex min-h-12 items-center justify-center rounded-full border border-white/30 bg-white/10 px-6 py-3 text-sm font-black uppercase text-white backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white"
            >
              {collection.secondaryAction.label}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
